import React from "react";
import { Send } from "lucide-react";
import { getContrastColor } from "./getContrastColor";

export interface Empleo {
  id?: string;
  titulo?: string;
  descripcion?: string;
  requisitos?: string;
  responsabilidades?: string;
  salario?: string;
  ubicacion?: string;
  modalidad?: string;
  imagen?: string;
}

interface Props {
  empleo?: Empleo;
  onEnviar: () => void;
  className?: string;
  styles?: any;
}

const CardEmpleo: React.FC<Props> = ({
  empleo,
  onEnviar,
  styles,
  className = "",
}) => {
  const titleColor = getContrastColor(styles?.backgroundColor);

  if (!empleo) return null;

  return (
    <div
      className={`
    w-full

    overflow-hidden
    rounded-3xl

    bg-white/10
    backdrop-blur-2xl
    border border-white/20

    grid
    grid-cols-1
    grid-rows-[auto_1fr]
    
    lg:grid-cols-[420px_minmax(0,1fr)]
    lg:grid-rows-1

    ${className}
  `}
    >
      {/* COLUMNA IMAGEN */}
      <div
        className="
    relative
    w-full

    aspect-[4/3]
    sm:aspect-[16/10]
    lg:aspect-auto
    lg:h-full

    overflow-hidden
  "
      >
        <img
          src={empleo.imagen || "/img/logo/LogoLinkServs.png"}
          alt={empleo.titulo}
          className="
      absolute
      inset-0
      w-full
      h-full
      object-cover
      object-center
    "
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

        <div className="absolute bottom-6 left-6 right-6">
          <h1
            className="text-2xl lg:text-3xl font-bold"
            style={{
              color: titleColor,
              fontFamily: styles?.fontFamily,
            }}
          >
            {empleo.titulo}
          </h1>

          <p
            className="mt-2 text-sm lg:text-base"
            style={{
              color: titleColor,
              fontFamily: styles?.fontFamily,
            }}
          >
            {empleo.ubicacion} • {empleo.modalidad}
          </p>
        </div>
      </div>

      {/* CONTENIDO */}
      <div
        className="
        h-full
        min-h-0
        min-w-0
        flex
        flex-col
"
      >
        {/* CONTENIDO SCROLL */}
        <div
          className="
      flex-1
      p-6
      space-y-6
      md:min-h-0
      md:overflow-y-auto
    "
        >
          <section>
            <h2
              className="text-xl font-semibold"
              style={{
                color: styles?.h2Color,
                fontSize: styles?.h2Size,
                fontFamily: styles?.fontFamily,
              }}
            >
              Descripción
            </h2>

            <p
              className="leading-relaxed"
              style={{
                color: styles?.textColor,
                fontSize: styles?.pSize,
                fontFamily: styles?.fontFamily,
              }}
            >
              {empleo.descripcion}
            </p>
          </section>

          <section>
            <h2
              className="text-xl font-semibold"
              style={{
                color: styles?.h2Color,
                fontSize: styles?.h2Size,
                fontFamily: styles?.fontFamily,
              }}
            >
              Requisitos
            </h2>

            <p
              className="leading-relaxed"
              style={{
                color: styles?.textColor,
                fontSize: styles?.pSize,
                fontFamily: styles?.fontFamily,
              }}
            >
              {empleo.requisitos}
            </p>
          </section>

          <section>
            <h2
              className="text-xl font-semibold"
              style={{
                color: styles?.h2Color,
                fontSize: styles?.h2Size,
                fontFamily: styles?.fontFamily,
              }}
            >
              Responsabilidades
            </h2>

            <p
              className="leading-relaxed"
              style={{
                color: styles?.textColor,
                fontSize: styles?.pSize,
                fontFamily: styles?.fontFamily,
              }}
            >
              {empleo.responsabilidades}
            </p>
          </section>
        </div>

        {/* PIE FIJO */}
        <div
          className="
          grid
          grid-cols-1
          gap-3
      
          sm:grid-cols-[200px_240px]
          sm:justify-between
      
          p-4
          border-t
          border-white/10
        "
        >
          <span
            className="
            flex
            items-center
        
            w-full
            h-11
        
            px-3
        
            rounded-xl
            border
            border-cyan-400/30
            bg-cyan-500/20
        
            text-xs
            lg:text-sm
        
            overflow-hidden
            whitespace-nowrap
            text-ellipsis
        
            text-left
          "
            title={empleo.salario || "Salario a convenir"}
          >
            <span className="block w-full truncate">
              {empleo.salario || "Salario a convenir"}
            </span>
          </span>

          <button
            onClick={onEnviar}
            className="
    w-full
    h-11

    flex
    items-center
    justify-center
    gap-2

    rounded-xl

    text-xs
    lg:text-sm

    overflow-hidden
  "
            style={{
              background: styles?.buttonColor
                ? styles.buttonColor
                : "linear-gradient(to right,#06b6d4,#2563eb)",
              color: styles?.buttonTextColor ?? "#fff",
            }}
          >
            <Send className="w-4 h-4 flex-shrink-0" />
            <span className="truncate">Insertar currículum</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardEmpleo;
